import { DialogConfirmation } from '@spotify-internal/encore-web';
import styled from 'styled-components';

export const StyledDialogConfirmation = styled(DialogConfirmation)`
  display: flex;
  align-items: center;

  & footer {
    & button {
      margin-inline-start: 0px;
    }
  }
`;
